const parseKeyValuePairType = (keyValuePairType = []) => {
  const keyValuePairTypeReducer = (a, { key, value }) => ({ ...a, [key]: value });
  return keyValuePairType.reduce(keyValuePairTypeReducer, {});
};

export default parseKeyValuePairType;
